"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class LoginAsPartner extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'loginAsPartner';
        this._username = initParams.username;
        this._user = initParams.user;
        this._token = initParams.token;
        this._mfaRequired = initParams.mfa_required;
        this._expires = initParams.expires;
        this._scope = (0, util_1.camelArray)(initParams.scope);
        this._tokenType = initParams.token_type;
        this._partnerOverride = initParams.partner_override;
    }
    set username(value) {
        console.error('Do not set objects this way');
    }
    get username() {
        return this._username;
    }
    set user(value) {
        console.error('Do not set objects this way');
    }
    get user() {
        return this._user;
    }
    set token(value) {
        console.error('Do not set objects this way');
    }
    get token() {
        return this._token;
    }
    set mfaRequired(value) {
        console.error('Do not set objects this way');
    }
    get mfaRequired() {
        return this._mfaRequired;
    }
    set expires(value) {
        console.error('Do not set objects this way');
    }
    get expires() {
        return this._expires;
    }
    set scope(value) {
        console.error('Do not set objects this way');
    }
    get scope() {
        return this._scope;
    }
    set tokenType(value) {
        console.error('Do not set objects this way');
    }
    get tokenType() {
        return this._tokenType;
    }
    set partnerOverride(value) {
        console.error('Do not set objects this way');
    }
    get partnerOverride() {
        return this._partnerOverride;
    }
}
exports.default = LoginAsPartner;
//# sourceMappingURL=loginAsPartner.js.map